<template>
	<div v-if="display" class="header-link">
		<a :href="registrarAppBaseUrl" class="">Регистратор</a>
	</div>
</template>

<script>
import { getConfig } from '@/auth'

export default {
	props: ['ipData'],
	data() {
		return {
			display: 0,
			registrarAppBaseUrl: getConfig().registrarAppBaseUrl,

		}
	},
	created() {
		this.display = this.ipData.is_internal;
	}
}
</script>